import React, {  useContext } from 'react';
import { Box, Link } from '@mui/material';
import { CustomerDataContext } from '../../components/context/CustomerDataProvider';
import pfeilrechts from '../../assets/images/pfeilrechts.svg';
import {loadSessionData} from '../../util/store';

interface Props { }



const ContactChangelink: React.FC<Props> = () => {
    const { customer } = useContext(CustomerDataContext);

    

    let show = true;

    function getContactChange(){
        let cid = loadSessionData("cid");
        let queryParams = new URLSearchParams(window.location.href);
       
        return "/ContactChange?cid=" + cid + "&authtoken="+queryParams.get("authtoken")+"&kundenakteShortUrl=" + queryParams.get("kundenakteShortUrl");
    }

    return <>
        
        {customer && show && <>

            <Link sx={{ display: 'flex-inline', textDecoration: 'none' }} href={getContactChange()}>
            <Box sx={{ fontSize: "1.0rem", display: 'flex-inline'  }}><img src={pfeilrechts} alt="Pfeil" className={"aktionPfeilRechts"} /> Kontaktdaten ändern</Box>
            </Link></>}
    </>
}

export default ContactChangelink;